import { createFileRoute } from "@tanstack/react-router";
import OrderDetail from "../../../Screens/OrderDetail";

export const Route = createFileRoute("/order/order-details/$orderId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  const search = Route.useSearch() as any;
  return (
    <OrderDetail orderId={orderId} restaurantIdOverride={search?.restaurantId} />
  );
}
